import Button from "@mui/material/Button";
// import Card from "@material-ui/core/Card";
import AppBar from "@material-ui/core/AppBar";
import useStyles from "../../../assets/CustomeMaterialStyleSheet";
import CloseIcon from "@mui/icons-material/Close";
import ImageList from "./ImageList";
import { getKycDocs } from "../../../Services/Admin/Kyc";
import { useContext, useEffect, useState } from "react";
import { ToasterContext } from "../../../App";
const Body = (props) => {
  const { handleImageClose, userId } = props;
  const classes = useStyles();
  const [kycDocs, setkycDocs] = useState("");
  const [tostify, setTostify] = useContext(ToasterContext);

  useEffect(() => {
    getKycDocs(userId).then((res) => {
      if (res.status === 200) {
        setkycDocs(res.data);
      } else {
        setTostify({
          ...tostify,
          visible: true,
          key: Math.random().toString(36).substring(7),
          type: res && res.status === 200 ? "success" : "error",
          message: res.message,
        });
      }
    });
    // eslint-disable-next-line
  }, []);
  return (
    <>
      <div className="table-kyc-view">
        <AppBar className={classes.header60}>
          <div
            id="add-user-header"
            className="d-flex align-items-center justify-content-between add-user-css"
          >
            <div>
              <h5 className="user-header-h5 mb-1 add-user-css">
                View User&apos;s Kyc
              </h5>
            </div>
            <Button
              id="coin-modal-close"
              className="btn-neutral mx-2 shadow-none d-30 border-0 p-0 d-inline-flex align-items-center justify-content-center text-white border-radius-15px"
              onClick={() => {
                handleImageClose();
              }}
            >
              <CloseIcon />
            </Button>
          </div>
        </AppBar>
      </div>
      <div className="inner-form-kyc-view">
        <div className={classes.paper60}>
          <div className="d-flex justify-content-between">
            <div className="mx-auto w100">
              <div className="">
                <div>
                  <ImageList {...props} kycDocs={kycDocs} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default Body;
